"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginPanelState = /** @class */ (function () {
    function LoginPanelState() {
        this.displayLoginMessage = false;
        this.displayLoginPanel = false;
    }
    return LoginPanelState;
}());
exports.default = LoginPanelState;
//# sourceMappingURL=LoginPanelState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/LoginPanel/LoginPanelState.js
// module id = 2382
// module chunks = 8